export default {
    template: `
        <div>
        <b-form-radio-group :name="String(id)" :checked="value" @input="updateValue" stacked>
            <b-form-radio v-for="item in options" class="my-3" :value="item.value">{{item['title_'+lang]}}</b-form-radio>
        </b-form-radio-group>
        </div>
    `,

    // enables v-model compatibility
    model: {
        prop: 'value',
        event: 'input'
    },

    props: {
        id: Number,
        options: Array,
        lang: String,
        value: {
            type: [String, Number],
            default: null
        }
    },

    methods: {
        updateValue(newValue) {
            if (newValue) this.$emit('input', newValue)
        }
    },

};

